import React from "react";
import "./all.css";
import classNames from "classnames";

export default function All(props) {
  const alllists = props.news.slice(6);
  return (
    <div className="all">
      {/* 全部图标 */}
      <img src={require("./img/all.png")} alt="" className="all-logo" />

      {alllists.map((item, index) => {
        return (
          <div className={classNames("all-all",{"all-margint" : index === 0})} key={item.uniquekey}
          >
            {/* 大列表 */}
            {item.thumbnail_pic_s03 ? (
              <div
                className="all-big-list"
                onClick={() => {
                  window.open(item.url);
                }}
              >
                {/* 大列表的标题 */}
                <div className="all-big-title">
                  <span
                    onClick={() => {
                      window.open(item.url);
                    }}
                  >
                    {item.title}
                  </span>
                </div>
                {/* 大列表下面的图片 */}
                <div className="all-big-imgs">
                  <img
                    src={item.thumbnail_pic_s}
                    alt=""
                    className="all-big-img"
                  />
                  <img
                    src={item.thumbnail_pic_s02}
                    alt=""
                    className="all-big-img"
                  />
                  <img
                    src={item.thumbnail_pic_s03}
                    alt=""
                    className="all-big-img"
                  />
                </div>
              </div>
            ) : (
                <div className="all-small-list" onClick={() => {
                  window.open(
                    item.url
                  )
              }}>
                {/* 前面的图片 */}
                <div
                  className="all-movie-box"
                  onClick={() => {
                    window.open(item.url);
                  }}
                >
                  {/* 图片 */}
                  {item.thumbnail_pic_s === "" && (
                    <img
                      src={require("../Movie/img/none.jpg")}
                      alt=""
                      className="all-movie-img"
                    />
                  )}
                  {item.thumbnail_pic_s !== "" && (
                    <img
                      src={item.thumbnail_pic_s}
                      alt=""
                      className="all-movie-img"
                    />
                  )}
                </div>
                {/* 文章信息 */}
                <div className="radio-newlist-right">
                  {/* 右边标题 */}
                  <div className="radio-right-title">
                    <span
                      onClick={() => {
                        window.open(item.url);
                      }}
                    >
                      {item.title}
                    </span>
                  </div>
                  {/* 右边时间 */}
                  <div className="radio-right-area">
                    <span>{item.author_name}</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>{item.date}更新</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
